module.exports = __webpack_public_path__ + "static/img/szafa_4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_4.svg
// module id = qRZK
// module chunks = 0